import apis from "../api"

export const admin = {
  namespaced: true,
  state: {
    users: {
      data: []
    },

    info: null
  },

  mutations: {
    LOAD(state, data) {
      state.users.data = data
    },

    SET(state, data) {
      state.info = data
    }
  },

  actions: {
    summaries({commit,dispatch}) {
      return new Promise((resolve,reject) => {
        apis.user.summaries()
        .then(response => {
          commit('LOAD', response)
          resolve(response)
        })
        .catch(error => {
          dispatch('feedback/show',{message: error, color: 'error'}, {root:true}) 
          reject(error)
        })
      })
    },

    get({commit,dispatch}, key) {
      return new Promise((resolve,reject) => {
        apis.user.admin_details(key)
          .then(response => {
            commit("SET", response);
            resolve(response)
          })
          .catch(error => {
            dispatch('feedback/show',{message: error, color: 'error'}, {root:true}) 
            reject(error)
          })  
      })
    },

    create({dispatch}, item) {
      return new Promise((resolve,reject) => {
        apis.user.create(item)
          .then(response => {
            console.log(response);
            dispatch('feedback/show', { message: `User ${response.email} created`, color: 'success' }, { root: true })
            resolve(response)
          })
          .catch(error => {
            dispatch('feedback/show',{message: error, color: 'error'}, {root:true}) 
            reject(error)
          })  
      })
    },

    update({dispatch}, payload) {
      return new Promise((resolve,reject) => {
        apis.user.admin_update(payload.key, payload.item)
          .then(response => {
            console.log(response);
            dispatch('feedback/show', { message: `User ${response.email} updated`, color: 'success' }, { root: true })
            resolve(response)
          })
          .catch(error => {
            dispatch('feedback/show',{message: error, color: 'error'}, {root:true}) 
            reject(error)
          })  
      })
    },

  },

  getters: {
    table(state) {
      return state.users.data
    },

    info(state) {
      return state.info
    }
  }
}